/// <reference path="../svg.d.ts" />
import React from 'react';
import { getIconProps, IconProps } from '../utils';
import ValueSvg from '../assets/ui/value.svg?react';

export const ValueIcon: React.FC<IconProps> = props => {
  return <ValueSvg {...getIconProps(props)} />;
};
